import { TipoFila } from '../enum';

export enum PapelFila {
  Nenhum = 0,
  Auxiliar = 1,
  Operador = 2,
  Gestor = 3,
  Administrador = 4
}

export enum PerfilAcessoFila {
  Operador = 1,
  Auxiliar = 2,
  Gestor = 5
}

/** Capacidades do usuário logado na fila (GET api/Fila/{idFila}/Permissoes). */
export class PermissoesFila {
  idFila: number;
  tipoFila: TipoFila;
  papel: PapelFila = PapelFila.Nenhum;
  verTodas = false;
  editarTodas = false;
  editarProprias = false;
  atribuir = false;
  gerirOperadores = false;
}
